import { FC } from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import { SvgIconProps } from '@mui/material/SvgIcon'

export const TrashIcon: FC = (props: SvgIconProps) => {
  return <DeleteIcon {...props} />
}
